<template>
  <section :id="`${blog.id}_record`" class="custom-blog-record-wrapper" :class="{ 'custom-highlight-record': blog.isSticky }">
    <FontAwesomeIcon v-if="blog.isSticky" icon="fas fa-thumbtack" class="custom-pin" />
    <div class="row">
      <div class="custom-title-row">
        <div class="custom-blog-title">{{ blog.blogName }}</div>
        <div class="custom-type">
          {{ blog.blogTypeName }}
        </div>
        <div class="custom-info">
          <FontAwesomeIcon v-if="postInfo !== null" icon="far fa-clock" />
          <span class="ms-1">{{ postInfo }}</span>
          <span v-if="blog.blogTags !== null" class="custom-tags-wrapper">
            tags: <span class="custom-tags">{{ blog.blogTags }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col custom-faded-content" v-html="content"></div>
    </div>
    <div class="row mt-1">
      <div class="col"></div>
      <div class="col-3 custom-right">
        <button class="btn btn-link" @click="readMore">read more</button>
      </div>
    </div>
    <div class="row custom-footer-row">
      <div class="custom-footer-wrapper">
        <div :id="`${blog.id}_footer`" class="row custom-footer">
          <div v-if="blog.isAllowComments" class="col-3 custom-commands">
            <FontAwesomeIcon icon="far fa-comments" class="custom-icon" />
            <span class="ms-1">Comments</span>
            <span v-if="blog.countComments > 0" class="badge-num-comments" title="# comments">{{ blog.countComments }}</span>
            <span class="custom-show" @click="showMore(1)">
              <FontAwesomeIcon v-if="!blog.showComment" icon="fas fa-chevron-down" />
              <FontAwesomeIcon v-else icon="fas fa-chevron-up" />
            </span>
          </div>
          <div v-if="blog.countAttachments > 0" class="col-3 custom-commands">
            <FontAwesomeIcon icon="fas fa-paperclip" class="custom-icon" />
            <span>Attachments</span>
            <span class="custom-show" @click="showMore(2)">
              <FontAwesomeIcon v-if="!blog.showAttachment" icon="fas fa-chevron-down" />
              <FontAwesomeIcon v-else icon="fas fa-chevron-up" />
            </span>
          </div>
          <div class="col"></div>
          <div class="col-3 custom-status-wrapper">
            <button v-if="isAuthor" class="btn btn-link" @click="edit">edit</button>
            <span class="custom-status">{{ status }}</span>
          </div>
        </div>
      </div>
    </div>
    <blog-attachments v-if="blog.showAttachment" :blog="blog" />
    <blog-comments v-if="blog.showComment" :blog="blog" />
  </section>
</template>
<script>
import { mapActions } from 'pinia'
import { blogStore } from '@/stores/blog'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BlogComments from '@/components/blog/blog-comments.vue'
import BlogAttachments from '@/components/blog/blog-attachments.vue'
import moment from 'moment'
export default {
  name: 'BlogRecord',
  components: {
    BlogComments,
    BlogAttachments,
    FontAwesomeIcon
  },
  props: {
    blog: {
      type: Object,
      default: () => {
        return {
          createdBy: null,
          blogName: null,
          id: null,
          isSticky: false,
          blogTypeName: null,
          createdByName: null,
          createdOn: null,
          blogTags: null,
          content: null,
          blogStatusName: null,
          countComments: 0,
          countAttachments: 0,
          showComment: false,
          showAttachment: false
        }
      }
    },
    user: Number
  },
  data() {
    return {
      recordCnt: 0
    }
  },
  emits: ['edit', 'more'],
  computed: {
    isAuthor() {
      let _is = false
      if (this.blog) {
        if (this.user) {
          if (parseInt(this.blog.createdBy) === parseInt(this.user)) {
            _is = true
          }
        }
      }
      return _is
    },
    postInfo() {
      let _data = null
      if (this.blog) {
        _data = `posted by ${this.blog.createdByName} on ${moment(this.blog.createdOn).format('dddd, MMMM Do YYYY, h:mm:ss a')}`
      }
      return _data
    },
    content() {
      let _data = null
      if (this.blog) {
        _data = this.blog.content
      }
      return _data
    },
    status() {
      let _data = null
      if (this.blog) {
        if (this.blog.blogStatusName) {
          if (this.blog.blogStatus === 4) {
            _data = `${this.blog.blogStatusName} on ${moment(this.blog.scheduledOn).format('dddd, MMMM Do YYYY')}`
          } else {
            _data = this.blog.blogStatusName
          }
        }
      }
      return _data
    }
  },
  methods: {
    ...mapActions(blogStore, ['resetShow']),
    edit() {
      this.$emit('edit', this.blog.blog)
    },
    cleanup(html) {
      // Create a new DOMParser
      var parser = new DOMParser()

      // Parse the copied HTML
      var doc = parser.parseFromString(html, 'text/html')

      // Get the root HTML element
      var rootHtmlElement = doc.documentElement

      // Create a new document to simplify the structure
      var simplifiedDoc = document.implementation.createHTMLDocument('')

      // Copy the head and body from the parsed HTML to the new document
      // simplifiedDoc.head.innerHTML = rootHtmlElement.querySelector('head').innerHTML;
      var bodyText = rootHtmlElement.querySelector('body').innerHTML.replace(/<\/?[^>]+(>|$)/g, '')
      if (bodyText.length > 2000) {
        simplifiedDoc.body.innerHTML = bodyText + ' ...'
      } else {
        simplifiedDoc.body.innerHTML = bodyText
      }
      // Get the simplified HTML
      var simplifiedHtml = simplifiedDoc.documentElement.outerHTML

      // Now 'simplifiedHtml' contains the cleaned-up HTML
      return simplifiedHtml
    },
    readMore() {
      this.$emit('more', this.blog.blog)
    },
    showMore(which) {
      this.$nextTick(() => {
        let data = {
          blog: this.blog.blog,
          showComment: which === 1 ? !this.blog.showComment : false,
          showAttachment: which === 2 ? !this.blog.showAttachment : false
        }
        this.resetShow(data)
        this.recordCnt++
        this.$forceUpdate()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-blog-record-wrapper {
  position: relative;
  width: 100%;
  border: 1px solid #b1b1b1;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 15px;
  box-shadow: 3px 3px 8px 0px rgba(0, 0, 0, 0.34);
  -webkit-box-shadow: 3px 3px 8px 0px rgba(0, 0, 0, 0.34);
  -moz-box-shadow: 3px 3px 8px 0px rgba(0, 0, 0, 0.34);
}
.custom-highlight-record {
  background-color: #dffff7;
}
.custom-title-row {
  position: relative;
  margin-right: 10px;
  margin-left: 10px;
  padding-left: 10px;
  width: 100%;
  border-bottom: 1px solid #ced4da;
}
.custom-blog-title {
  font-size: 1.6em;
  font-weight: 600;
  margin-bottom: 5px;
}
.custom-type {
  position: absolute;
  top: 15px;
  right: 35px;
  text-align: right;
  font-style: italic;
}
.custom-info {
  font-size: 0.9em;
  margin-bottom: 5px;
  position: absolute;
  top: -7px;
  right: 35px;
  color: #0a58ca;
}
.custom-tags-wrapper {
  position: relative;
  font-size: 1em;
  float: right;
  margin-left: 10px;
}
.custom-tags {
  font-style: italic;
}
.custom-content {
  padding: 5px;
}
.custom-right {
  text-align: right;
}
.custom-edit-wrapper {
  position: relative;
  display: inline-flex;
}
.custom-pin {
  position: absolute;
  left: 4px;
  top: 5px;
  font-size: 0.8em;
  color: #b1b1b1;
}
.custom-footer-row {
  margin-bottom: 0;
  margin-top: 0;
}
.custom-footer {
  position: relative;
  padding-top: 10px;
  margin: 0;
  height: 32px;
}
.custom-footer-wrapper {
  width: 100%;
  border-top: 1px solid #ced4da;
}
.custom-icon {
  position: relative;
  top: -5px;
  width: 32px;
}
.custom-status-wrapper {
  position: relative;
  top: -10px;
  text-align: right;
}
.custom-status {
  position: relative;
  font-size: 0.9em;
  margin-left: 5px;
  top: 2px;
}
.badge-num-comments {
  position: relative;
  top: -7px;
  display: inline-flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  color: white;
  background: darkgreen;
  position: relative;
  box-sizing: border-box;
  text-align: center;
  vertical-align: middle;
  font-weight: normal;
  font-size: 12px;
  border-radius: 18px;
  padding: 0 4px;
  height: 18px;
  min-width: 18px;
}
.custom-show {
  cursor: pointer;
  margin-left: 5px;
}
.custom-faded-content {
  -webkit-mask-image: linear-gradient(to bottom, black 50%, transparent 100%);
  mask-image: linear-gradient(to bottom, black 50%, transparent 100%);
  height: 150px;

  overflow-x: hidden;
  overflow-y: hidden;
}
.custom-commands {
  display: inline-flex;
}
</style>
